<template>
  <v-card>
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon large>edit</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Edit Company</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text style="max-height: 85%">
      <v-form ref="editAgentForm" v-model="valid" lazy-validation>
        <v-layout column>
          <v-flex xs12>
            <v-text-field
              outline
              label="Full Name *"
              required
              v-model="editItem.name"
              :rules="requiredRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              outline
              label="Mobile *"
              v-model="editItem.mobile"
              required              
              :rules="requiredRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              outline
              label="Email"
              v-model="editItem.email"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              outline
              label="Address"
              v-model="editItem.address"
            ></v-text-field>
          </v-flex>
          <v-textarea v-model="editItem.notes" outline label="Notes"></v-textarea>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="onCancelled">Cancel</v-btn>
      <v-btn
        color="blue"
        @click="editItemDo"
        :disabled="!valid || actionButtonClicked"
        :loading="actionButtonClicked"
        >Update</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { GENDERS } from "../../mdsir/const";

export default {
  props: ["editItem"],
  data() {
    return {
      actionButtonClicked: false,
      valid: true,
    };
  },
  methods: {
    onCancelled() {
      this.$emit("cancelled");
    },
    validate() {
      if (this.$refs.editAgentForm.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.editAgentForm.reset();
    },
    resetValidation() {
      this.$refs.editAgentForm.resetValidation();
    },
    // clearForm() {
    //   this.newItem.full_name = "";
    //   this.newItem.age = "";
    //   this.newItem.phone = "";
    //   this.newItem.notes = "";
    // },
    editItemDo() {
      if (this.$refs.editAgentForm.validate()) {
        this.actionButtonClicked = true;
        this.put("/company", this.editItem).then((res) => {
          if (res.data.success) {
            this.onCancelled();
          }
          this.snackbarShow(res.data);
          this.actionButtonClicked = false;
        });
      }
    },
  },
  mounted() {},
  created() {
    this.GENDERS = GENDERS;
  },
};
</script>